<template>
  <section id="relic-detail-census">
    <edit-header-vue title="测绘信息" :visible-action="false" />

    <!-- 照片类型 -->
    <div class="census-item">
      <!-- 单个类型图片头部 -->
      <div class="census-item__header flex-align">
        <!-- 图片类型描述 -->
        <span class="header-type font-labelheavy">照片</span>

        <!-- 图片上传 -->
        <file-uploader-vue
          class="header-upload"
          v-if="limitShow"
          :multifile="true"
          @onFileChange="handlePhotoBeforeUpload"
        >
          <el-button
            type="text"
            icon=" iconfont icon-shangchuan"
            class="header-upload__btn flex-align font-table__header"
          >
            上传照片
          </el-button>
        </file-uploader-vue>

        <!-- 批量编辑 -->
        <el-button
          type="text"
          icon=" iconfont icon-bianji"
          @click="handleEditPhotoClick"
          class="header-edit flex-align font-table__header"
          v-if="limitShow && relicPhotoList[0]"
        >
          批量编辑
        </el-button>
      </div>

      <!-- 图片列表 -->
      <ul class="census-imgs flex-align">
        <li
          v-for="(item, index) in relicPhotoList"
          :key="index"
          class="census-imgs__item"
          @click="handlePhotoClick(item.relicPhotoAutoIncrementId, index)"
        >
          <img :src="item.thumb" alt="" />
        </li>
      </ul>
      <div
        class="census-more font-h3 flex-center"
        v-if="showSearchPhotoMore"
        @click="getRelicPhoto"
      >
        <i class="iconfont icon-chakangengduo"></i>查看更多
      </div>
    </div>

    <!-- 图纸类型 -->

    <div class="census-item">
      <!-- 单个类型图片头部 -->
      <div class="census-item__header flex-align">
        <!-- 图片类型描述 -->
        <span class="header-type font-labelheavy">图纸</span>

        <!-- 图片上传 -->
        <file-uploader-vue
          @onFileChange="handleDrawBeforeUpload"
          class="header-upload"
          :multifile="true"
          v-if="limitShow"
        >
          <el-button
            type="text"
            icon=" iconfont icon-shangchuan"
            class="header-upload__btn flex-align font-table__header"
          >
            上传图纸
          </el-button>
        </file-uploader-vue>

        <!-- 批量编辑 -->
        <el-button
          v-if="limitShow && relicDrawingList[0]"
          type="text"
          icon=" iconfont icon-bianji"
          @click="handleEditDrawClick"
          class="header-edit flex-align font-table__header"
        >
          批量编辑
        </el-button>
      </div>

      <!-- 图纸列表 -->
      <ul class="census-imgs flex-align">
        <li
          v-for="(item, index) in relicDrawingList"
          :key="index"
          class="census-imgs__item"
          @click="handleDrawClick(item.relicDrawingAutoIncrementId, index)"
        >
          <img :src="item.thumb" alt="" />
        </li>
      </ul>
      <div
        class="census-more font-h3 flex-center"
        @click="getRelicDrawing"
        v-if="showSearchDrawingMore"
      >
        <i class="iconfont icon-chakangengduo"></i>查看更多
      </div>
    </div>

    <!-- 点云切片 -->

    <relic-detail-census-point-cloud
      @onUpdatePointCloud="handleUpdatePointCloud"
      @onDeletePointCloudImg="handleDeletePointCloudImg"
      :pointCloudImgList="pointCloudImgList"
    />

    <!-- 批量编辑 -->
    <relic-detail-census-edit-vue
      v-model="visibleEdit"
      :title="editDialogTitle"
      :allEditImgs="allEditImgs"
      :imgType="imgType"
      :swiperImgIndex="swiperImgIndex"
      @onChangePhotoShowInMap="handleChangePhotoShowInMap"
      @onConfirmDeletePhoto="handleConfirmDeletePhoto"
      @onChangeDrawShowInMap="handleChangeDrawShowInMap"
      @onConfirmDeleteDraw="handleConfirmDeleteDraw"
      @onCloseUpdatePhoto="handleCloseUpdatePhoto"
    />

    <!-- 图片查看 -->
    <relic-detail-census-swiper-vue
      :imgInfoByKid="imgInfoByKid"
      :swiperImgInformation="swiperImgInformation"
      :imgType="imgType"
      :swiperImgIndex="swiperImgIndex"
      v-model="visibleSwiper"
      @onToNextPhotoSlide="handleToNextPhotoSlide"
      @onToLastPhotoSlide="handleToLastPhotoSlide"
      @onToNextDrawSlide="handleToNextDrawSlide"
      @onToLastDrawSlide="handleToLastDrawSlide"
    />
    <!-- 上传图片前编辑图片信息弹窗 -->
    <relic-detail-census-uploading-vue
      v-if="visibleUploadingSwiper"
      v-model="visibleUploadingSwiper"
      :uploadingFileList="uploadingFileList"
      @onSuccessUploadingImgs="handleSuccessUploadingImgs"
      @onCancelUploading="handleCancelUploading"
      :imgType="imgType"
    />
  </section>
</template>

<script>
import editHeaderVue from '../layout/edit-header.vue';
import relicDetailCensusSwiperVue from './relic-detail-census-swiper.vue';
import relicDetailCensusEditVue from './relic-detail-census-edit.vue';
import {
  getRelicPhoto,
  deleteRelicPhoto,
  getPhotoInformation,
  updateRelicPhotoInMap,
  getRelicDrawing,
  updateDrawingInMap,
  deleteRelicDrawing,
  getDrawingInformation,
  GetPointCloudPhoto,
  UpdatePointCloudPhoto,
  DeletePointCloudImg
} from '../../api';
import relicDetailCensusUploadingVue from './relic-detail-census-uploading.vue';
import { mapGetters } from 'vuex';
import fileUploaderVue from '../layout/file-uploader.vue';
import RelicDetailCensusPointCloud from './relic-detail-census-point-cloud.vue';
import { getFileName } from '../../config/utils';
function compare(arg) {
  return function(a, b) {
    return a[arg] - b[arg];
  };
}

export default {
  name: 'RelicDetailCensus',
  components: {
    editHeaderVue,
    relicDetailCensusEditVue,
    relicDetailCensusSwiperVue,
    fileUploaderVue,
    relicDetailCensusUploadingVue,
    RelicDetailCensusPointCloud
  },
  async mounted() {
    this.getRelicPhoto();
    this.getRelicDrawing();
    await this.initPointCloudImg();
  },
  data() {
    return {
      imgType: 0, //区分照片类型
      visibleSwiper: false, // 控制轮播弹窗显示
      visibleEdit: false,
      editDialogTitle: '照片',
      photoPage: 1,
      drawingPage: 1,
      showSearchPhotoMore: true,
      showSearchDrawingMore: true, //显示图纸的more
      relicPhotoList: [], //保存建筑照片数组
      relicPhotoTotalNum: 0, //保存照片总数
      relicDrawingList: [], //保存建筑图纸数组
      relicDrawingTotalNum: 0, //保存图纸总数
      visibleUploadingSwiper: false, //显示上传图片前编辑弹窗
      photoInfo: [
        {
          label: '名称',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '照片号',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '底片号',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '拍摄者',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '拍摄时间',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '拍摄方位',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '说明',
          value: '',
          placeholder: '非必填',
          options: {
            type: 'textarea'
          }
        }
      ],
      drawInfo: [
        {
          label: '名称',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '图号',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '比例',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '绘制人',
          value: '',
          placeholder: '非必填'
        },
        {
          label: '绘制时间',
          value: '',
          placeholder: '非必填'
        }
      ],
      imgInfoByKid: [], //用于展示图片
      uploadBaseOption: [], //用于设置上传的配置
      uploadingFileList: [], //上传照片信息储存列表
      fileList: [], //用于保存文件类型
      allEditImgs: [], //用于批量编辑img的数组
      client: null, //保存OSS配置
      swiperImgInformation: {}, //用于存储点击单张图片的信息
      swiperImgIndex: 0, //记录下表
      pointCloudImgList: [] //储存点云切片
    };
  },
  computed: {
    ...mapGetters('login', ['limitShow']),
    relicAutoIncrementId() {
      return this.$route.params.id;
    }
  },
  watch: {
    //监控上传弹窗的现实
    uploadingFileList() {
      if (
        this.uploadingFileList.length != 0 &&
        this.uploadingFileList.length == this.fileList.length
      ) {
        this.visibleUploadingSwiper = true;
      }
    }
  },
  methods: {
    async handleUpdatePointCloud(params) {
      await UpdatePointCloudPhoto(params);
      await this.initPointCloudImg();
    },

    /**
     * 初始化点云照片
     */
    async initPointCloudImg() {
      const params = {
        doPaging: false,
        relicAutoIncrementId: this.relicAutoIncrementId
      };
      const {
        data: {
          data: { items }
        }
      } = await GetPointCloudPhoto(params);
      this.pointCloudImgList = items;
    },

    async handleDeletePointCloudImg(id) {
      await DeletePointCloudImg(id);
      this.$prompt('删除成功');
      await this.initPointCloudImg();
    },

    /**
     * 分页获取图片
     */
    getRelicPhoto() {
      getRelicPhoto({
        page: this.photoPage,
        relicAutoIncrementId: this.relicAutoIncrementId
      }).then(res => {
        if (res.data.code == 200) {
          this.relicPhotoTotalNum = res.data.data.totalNum;
          this.relicPhotoList.push(...res.data.data.items);
          if (this.relicPhotoList.length < res.data.data.totalNum) {
            this.showSearchPhotoMore = true;
            this.photoPage = this.photoPage + 1;
          } else {
            this.showSearchPhotoMore = false;
          }
        }
      });
    },
    /**
     * 监听编辑回调
     */
    handleCloseUpdatePhoto(imgType) {
      if (imgType == 1) {
        this.photoPage = 1;
        this.relicPhotoList = [];
        this.getRelicPhoto();
      } else if (imgType == 2) {
        this.relicDrawingList = [];
        this.drawingPage = 1;
        this.getRelicDrawing();
      }
    },
    /**
     * 上传图片之前回调
     */
    handlePhotoBeforeUpload({ files, result }) {
      //
      this.imgType = 1;
      let fileList = files;
      this.fileList = files;
      this.uploadBaseOption = this.photoInfo;

      for (let i = 0; i < fileList.length; i++) {
        const name = getFileName(files[i]);
        const id = name.split('.')[0];
        let test = {};
        test.src = result[i].value;
        test.file = files[i];
        test.baseOption = JSON.parse(JSON.stringify(this.uploadBaseOption));
        test.baseOption[1].value = id;
        test.fileId = i;
        test.visibleMap = true;
        test.visibleEdit = true;
        this.uploadingFileList.push(test);
      }
      this.visibleUploadingSwiper = true;
    },

    /**
     * 监听上传成功回掉
     */
    handleSuccessUploadingImgs(imgType) {
      this.uploadingFileList = [];
      this.fileList = [];
      if (imgType == 1) {
        this.photoPage = 1;
        this.relicPhotoList = [];
        this.getRelicPhoto();
      } else if (imgType == 2) {
        this.relicDrawingList = [];
        this.drawingPage = 1;
        this.getRelicDrawing();
      }
    },

    /**
     * 监听取消上传
     */
    handleCancelUploading() {
      this.uploadingFileList = [];
      this.fileList = [];
    },

    /**
     * * 点击照片回调
     * @param {number} id 照片自增id
     * @param {number} index 照列表下标位置
     */
    handlePhotoClick(id, index) {
      if (this.relicPhotoTotalNum) {
        this.imgType = 1;
        getRelicPhoto({
          relicAutoIncrementId: this.relicAutoIncrementId,
          doPaging: false
        }).then(res => {
          if (res.data.code == 200) {
            this.allEditImgs = res.data.data.items;
            this.handleProcessEditPhoto(id, index);
          }
        });
      }
    },
    /**
     * 处理照片信息
     * @param {number} id 照片自增id
     * @param {number} index 照列表下标位置
     */
    handleProcessEditPhoto(id, index) {
      getPhotoInformation(id).then(res => {
        if (res.data.code == 200) {
          this.swiperImgInformation = res.data.data;
          this.swiperImgInformation.visibleEdit = false;
          this.imgInfoByKid = JSON.parse(JSON.stringify(this.photoInfo));
          let {
            description,
            filmId,
            photoId,
            photoName,
            photographer,
            shootDirection,
            shootTime
          } = this.swiperImgInformation;
          this.imgInfoByKid[0].value = photoName;
          this.imgInfoByKid[1].value = photoId;
          this.imgInfoByKid[2].value = filmId;
          this.imgInfoByKid[3].value = photographer;
          this.imgInfoByKid[4].value = shootTime;
          this.imgInfoByKid[5].value = shootDirection;
          this.imgInfoByKid[6].value = description;
          this.imgType = 1; //表示1传入的为照片
          this.swiperImgIndex = index;
          this.visibleSwiper = true;
        }
      });
    },
    /**
     * 监听去下一张照片
     * @param {Number} imgIndex 下一张的下标
     */
    handleToNextPhotoSlide(imgIndex) {
      if (this.allEditImgs[imgIndex]) {
        this.handleProcessEditPhoto(
          this.allEditImgs[imgIndex].relicPhotoAutoIncrementId,
          imgIndex
        );
      }
    },
    /**
     * 监听去上一张照片
     */
    handleToLastPhotoSlide(imgIndex) {
      if (imgIndex >= 0) {
        this.handleProcessEditPhoto(
          this.allEditImgs[imgIndex].relicPhotoAutoIncrementId,
          imgIndex
        );
      }
    },

    /**
     * * 批量编辑照片
     */
    handleEditPhotoClick() {
      if (this.relicPhotoTotalNum) {
        this.imgType = 1;
        getRelicPhoto({
          relicAutoIncrementId: this.relicAutoIncrementId,
          doPaging: false
        }).then(res => {
          if (res.data.code == 200) {
            this.allEditImgs = res.data.data.items;
            this.visibleEdit = true;
          }
        });
      }
    },
    /**
     * 监听改变照片地图状态回掉
     * @param {number} photoId 照片自增id
     * @param {boolean} showInMap 地图显示
     */
    handleChangePhotoShowInMap(photoId, showInMap) {
      //
      //
      updateRelicPhotoInMap({
        relicPhotoAutoIncrementId: photoId,
        showInMap: !showInMap
      }).then(res => {
        if (res.data.code == 200) {
          this.handleEditPhotoClick();
        }
      });
    },

    /**
     * 批量监听删除图片
     * @param {number} id 删除照片的自增id
     */
    async handleConfirmDeletePhoto(id) {
      if(Array.isArray(id)) {
        let num = 0
        for (const item of id) {
          const res = await deleteRelicPhoto(item)
          if(res.data.code == 200){
            num++
          }
        }
        if(num == id.length){
          this.handleEditPhotoClick();
          this.$prompt('删除成功');
        } else {
          this.$prompt('删除成功');
        }
      } else {
        const res = await deleteRelicPhoto(id);
        if (res.data.code == 200) {
          this.handleEditPhotoClick();
          this.$prompt('删除成功');
        }
      }

    },
    /**
     * 监听批量编辑删除图纸回掉
     */
    async handleConfirmDeleteDraw(drawId) {
      if (Array.isArray(drawId)) {
        let num = 0
        for (const item of drawId) {
          const res = await deleteRelicDrawing(item)
          if(res.data.code == 200){
            num++
          }
        }
        if(num == drawId.length){
          this.handleEditDrawClick();
          this.$prompt('删除成功');
        } else {
          this.$prompt('删除成功');
        }
      } else {
        const res = await deleteRelicDrawing(drawId);
        if (res.data.code == 200) {
          this.handleEditDrawClick();
        }
      }
    },
    /**
     * 异步删除
     */
    // async handleDeleteRelicPhoto(url, id) {
    //   try {
    //
    //     let result = await this.client.delete(url);
    //
    //   } catch (e) {
    //
    //   }
    // },

    /**
     * 分页查找图纸
     */
    getRelicDrawing() {
      getRelicDrawing({
        page: this.drawingPage,
        relicAutoIncrementId: this.relicAutoIncrementId
      }).then(res => {
        if (res.data.code == 200) {
          this.relicDrawingTotalNum = res.data.data.totalNum;
          this.relicDrawingList.push(...res.data.data.items);
          const visibleSort = this.relicDrawingList.every(item => {
            return item.drawingId;
          });
          if (visibleSort) {
            this.relicDrawingList = this.relicDrawingList.sort(
              compare('drawingId')
            );
          }
          if (this.relicDrawingList.length < res.data.data.totalNum) {
            this.showSearchDrawingMore = true;
            this.drawingPage = this.drawingPage + 1;
          } else {
            this.showSearchDrawingMore = false;
          }
        }
      });
    },
    /**
     * 点击图纸上传回掉
     */
    handleDrawBeforeUpload({ files, result }) {
      this.imgType = 2;
      let fileList = files;
      this.fileList = files;
      //
      let visibleFormat = false;
      this.uploadBaseOption = this.drawInfo;
      Array.from(fileList).forEach((index, item) => {});
      for (let i = 0; i < fileList.length; i++) {
        let test = {};
        const name = getFileName(files[i]);
        const id = name.split('.')[0];
        test.src = result[i].value;
        test.file = files[i];
        test.baseOption = JSON.parse(JSON.stringify(this.uploadBaseOption));
        test.baseOption[1].value = id;
        test.fileId = i;
        test.visibleMap = true;
        test.visibleEdit = true;
        test.visibleSave = false; //用于判断是否上传至OSS中
        this.uploadingFileList.push(test);
      }
      this.visibleUploadingSwiper = true;
    },
    /**
     * 点击图纸回调
     * @param {number} id 图纸自增id
     * @param {number} index 图纸位置
     */
    handleDrawClick(id, index) {
      getRelicDrawing({
        doPaging: false,
        relicAutoIncrementId: this.relicAutoIncrementId
      }).then(res => {
        if (res.data.code == 200) {
          this.allEditImgs = res.data.data.items;

          this.handleProcessEditDraw(id, index);
        }
      });
      // this.imgInfoByKid = this.drawInfo;
      // this.visibleSwiper = true;
    },

    /**
     * 进入弹窗前信息处理回调
     */
    handleProcessEditDraw(id, index) {
      getDrawingInformation(id).then(res => {
        this.swiperImgInformation = res.data.data;
        this.swiperImgInformation.visibleEdit = false;
        this.imgInfoByKid = JSON.parse(JSON.stringify(this.drawInfo));
        let {
          createTime,
          creator,
          drawingId,
          drawingName,
          scale
        } = this.swiperImgInformation;
        this.imgInfoByKid[0].value = drawingName;
        this.imgInfoByKid[1].value = drawingId;
        this.imgInfoByKid[2].value = scale;
        this.imgInfoByKid[3].value = creator;
        this.imgInfoByKid[4].value = createTime;
        this.imgType = 2;
        this.swiperImgIndex = index;
        this.visibleSwiper = true;
      });
    },
    /**
     * 监听下一张图纸
     */
    handleToNextDrawSlide(imgIndex) {
      if (this.allEditImgs[imgIndex]) {
        this.handleProcessEditDraw(
          this.allEditImgs[imgIndex].relicDrawingAutoIncrementId,
          imgIndex
        );
      }
    },

    /**
     * 监听上一张图纸
     */
    handleToLastDrawSlide(imgIndex) {
      if (imgIndex >= 0) {
        this.handleProcessEditDraw(
          this.allEditImgs[imgIndex].relicDrawingAutoIncrementId,
          imgIndex
        );
      }
    },
    /**
     * 点击批量编辑图纸
     */
    handleEditDrawClick() {
      // this.visibleEdit = true;
      if (this.relicDrawingTotalNum) {
        getRelicDrawing({
          doPaging: false,
          relicAutoIncrementId: this.relicAutoIncrementId
        }).then(res => {
          if (res.data.code == 200) {
            this.allEditImgs = res.data.data.items;
            this.imgType = 2;
            this.visibleEdit = true;
          }
        });
      }
    },
    /**
     * 监听图纸是否显示在地图
     */
    handleChangeDrawShowInMap(drawId, showInMap) {
      updateDrawingInMap({
        relicDrawingAutoIncrementId: drawId,
        showInMap: !showInMap
      }).then(res => {
        if (res.data.code == 200) {
          this.handleEditDrawClick();
        }
      });
    }
  }
};
</script>

<style lang="scss">
#relic-detail-census {
  margin-top: 53px;
  .edit-header {
    padding-bottom: 10px;
  }
  .census {
    &-more {
      margin-top: 15px;
      cursor: pointer;
      color: $color-primary;
    }
    &-item {
      margin-bottom: 50px;
      &__header {
        margin-top: 2px;
        height: 40px;
        .header {
          &-type {
            color: #888;
          }
          &-upload {
            margin-left: 32px;
            position: relative;
            &__btn {
              text-decoration: none;
              .iconfont {
                margin-right: 5px;
                font-size: 20px;
                transform: translateY(-2.5px);
              }
            }
            input {
              display: inline-block;
              width: 80px;
              height: 20px;
              opacity: 0;
              position: absolute;
              top: 0;
              z-index: 100;
            }
          }
          &-edit {
            margin-left: 30px;
            text-decoration: none;
            .iconfont {
              font-size: 30px;
              transform: translateY(-2px);
            }
          }
        }
      }
    }
    &-imgs {
      flex-wrap: wrap;
      &__item {
        margin-right: 30px;
        margin-top: 30px;
        width: 120px;
        height: 80px;
        background-color: #f2f2f2;
        border: 1px solid $color-border;
        cursor: pointer;
        img {
          width: 120px;
          height: 80px;
        }
        &:nth-child(7n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
